'use client';
import { FaIcon } from '../../../../components/icon';
import { faLongArrowAltDown } from '../../../../components/icon/FaIcon/FaIcon';
import ImageView from '../../../../components/ui/ImageView/ImageView';
import fontsStyles from '../../../../styles/modules/fonts.module.scss';
import utilsStyles from '../../../../styles/modules/utils.module.scss';
import type { TradeConfirm } from '../../types';
import { createStagingInfo } from '../../utils';
import styles from './TradeConfirmList.module.scss';

type TradeLabel = TradeConfirm['sets'][number]['inGoods'][number]['label'];

export type TradeConfirmListProps = {
  tradeConfirmData: TradeConfirm;
};

function TradeConfirmList({ tradeConfirmData }: TradeConfirmListProps) {
  return (
    <div className={`${styles.tradeCollectionList}`}>
      {tradeConfirmData ? (
        <div>
          {/* 交換に出す景品のセクション */}
          <h5 className={`${utilsStyles.textBold} ${utilsStyles.mtSmall}`}>交換に出す景品</h5>
          {tradeConfirmData.sets
            .flatMap((set) => set.outGoods)
            .map((good) => (
              <div key={good.id} className={`${styles.itemCard}`}>
                <div className={`${styles.itemDetailWrapper} ${utilsStyles.mtXSmall}`}>
                  <div className={styles.itemImage}>
                    <ImageView alt={good.label.stagingName} src={good.imageUrl} />
                  </div>
                  <div className={`${styles.itemDetail} ${utilsStyles.mlSmall}`}>
                    <div className={styles.stagingRankWrapper}>{staging(good.label)}</div>
                    <div className={styles.itemNameWrapper}>
                      <p className={`${styles.itemName} ${utilsStyles.textBold}`}>{good.name}</p>
                      <p className={`${utilsStyles.textBold} ${utilsStyles.mtSmall} ${utilsStyles.textLarge}`}>
                        交換に出す景品：
                        <span className={`${utilsStyles.textBold} ${utilsStyles.textXLarge}`}>{good.count}</span>個
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}

          {/* 矢印アイコン */}
          <div className={`${styles.iconWrapper} ${utilsStyles.centeredHorizontal} ${utilsStyles.mtSmall} `}>
            <FaIcon icon={faLongArrowAltDown} size='2x' />
          </div>

          {/* 獲得する景品のセクション */}
          <h5 className={utilsStyles.textBold}>獲得する景品</h5>
          {tradeConfirmData.sets
            .flatMap((set) => set.inGoods)
            .map((good) => (
              <div key={good.id} className={`${styles.itemCard}`}>
                <div className={`${styles.itemDetailWrapper} ${utilsStyles.mtXSmall}`}>
                  <div className={styles.itemImage}>
                    <ImageView alt={good.label.stagingName} src={good.imageUrl} />
                  </div>
                  <div className={`${styles.itemDetail} ${utilsStyles.mlSmall}`}>
                    <div className={styles.stagingRankWrapper}>{staging(good.label)}</div>
                    <div className={styles.itemNameWrapper}>
                      <p className={`${styles.itemName} ${utilsStyles.textBold}`}>{good.name}</p>
                      <p
                        className={` ${utilsStyles.textBold} ${utilsStyles.primaryColor} ${utilsStyles.mtSmall} ${utilsStyles.textLarge}`}
                      >
                        獲得する景品：
                        <span className={`${utilsStyles.textBold} ${utilsStyles.textXLarge}`}>{good.count}</span>個
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>
      ) : (
        <div>
          <p>交換確認データがありません。</p>
        </div>
      )}
    </div>
  );
}

function getRankStyle(rank: number) {
  switch (rank) {
    case 1:
      return styles.rank1;
    case 2:
      return styles.rank2;
    default:
      return styles.defaultRankImage;
  }
}

function staging(label: TradeLabel) {
  if (label.stagingKey) {
    const stagingInfo = createStagingInfo(label.stagingKey);
    return (
      <div className={`${styles.stagingRank} ${getRankStyle(Number(stagingInfo.stagingRank))}`}>
        <p className={`${styles.stagingText} ${fontsStyles.montserrat}`}>
          {stagingInfo.stagingText}
          <small>賞</small>
        </p>
      </div>
    );
  }

  return <></>;
}

export default TradeConfirmList;
